import { post } from "../utils/backend";
import { uploadAppFileToOss } from "../global/OssUploadApi";
import { compressFileToJpegFile } from "../utils/imageCompressToJpeg";
import { useLongfansMock } from "../global/GlobalMock";
import { mockUpdateProfile, mockUploadAvatar } from "./UserProfileMock";

export type UpdateProfileParam = {
  nickname: string;
  /** 自助填写的图片地址，对应 customer.avatar_url */
  avatarUrl: string;
  /** M 男 F 女 U 未选 */
  gender: string;
  /** 公历 yyyy-MM-dd，空表示不填 */
  birthday: string;
};

const updateProfile = async (p: UpdateProfileParam): Promise<boolean> => {
  if (useLongfansMock) {
    return mockUpdateProfile(p);
  }
  const res = await post<UpdateProfileParam, boolean>("/api/user/updateProfile", {
    nickname: p.nickname.trim(),
    avatarUrl: p.avatarUrl.trim(),
    gender: p.gender,
    birthday: p.birthday.trim(),
  });
  if (typeof res === "string") {
    return false;
  }
  return !!res;
};

const uploadAvatarFromCompressedFile = async (file: File): Promise<string | null> => {
  if (useLongfansMock) {
    return mockUploadAvatar();
  }
  let jpegFile: File;
  try {
    jpegFile = await compressFileToJpegFile(file, 640, 0.86);
  } catch {
    return null;
  }
  try {
    return await uploadAppFileToOss(jpegFile, "USER_AVATAR");
  } catch {
    return null;
  }
};

export const UserProfileApi = {
  updateProfile,
  uploadAvatarFromCompressedFile,
};
